import { Expose } from "class-transformer";
import CastExaminationRes from "types/res/castExamination/CastExaminationRes";

export default class NeedCastExaminationRes extends CastExaminationRes {
  @Expose() readonly needExamination!: boolean;
}
